import { BarChart3, Mic, Users } from "lucide-react";

export const pillars = [
  {
    icon: Users,
    title: "3–5 Student Micro-Cohorts",
    body: "Tiny classes mean every child is seen, heard and corrected in the moment — never lost in a crowd.",
  },
  {
    icon: Mic,
    title: "80%+ Active Speaking Time",
    body: "Lessons are built around talking, not watching. Children spend the majority of each session using English out loud.",
  },
  {
    icon: BarChart3,
    title: "Rigorous CEFR Alignment",
    body: "Every learner is placed, tracked and reported against international benchmarks, so progress is measurable.",
  },
];

export const steps = [
  {
    title: "1. Free assessment",
    body: "A 1-on-1 online session with Ms. Salma who listens to your child speak and read, then maps their current CEFR level.",
  },
  {
    title: "2. Written learning plan",
    body: "You receive a plan setting out starting level, target outcomes for the term, and the cohort and time slot we recommend.",
  },
  {
    title: "3. Live micro-cohort lessons",
    body: "Your child joins a group of no more than five children of the same age band and level, meeting 2 or 4 times per week.",
  },
  {
    title: "4. Homework and monthly reports",
    body: "Weekly homework is marked with Ms. Salma's feedback, and every month you get a written CEFR progress report.",
  },
];
